module.exports = __webpack_public_path__ + "img/about-banner.9e9a3c45.jpg";